<mds-dialog dialogTitle="Confirm Site Details" [attr.data-cy]="'siteRegisterModal'">
    <mds-dialog-content>
        <!-- Site Information -->
        <mds-card [appearance]="'elevated'" class="mb-medpace-item">
            <mds-card-content>
                <h3 class="mb-8">Site Information</h3>
                <div class="flex flex-col gap-medpace-item w-full">
                    <div>
                        <h5>Site #</h5>
                        <span>{{ site()?.info?.siteNumber }}</span>
                    </div>
                    <div>
                        <h5>Institution Name</h5>
                        <span>{{ site()?.info?.name }}</span>
                    </div>
                    <div>
                        <h5>PI Last Name</h5>
                        <span>{{ site()?.info?.pilastName }}</span>
                    </div>
                </div>
            </mds-card-content>
        </mds-card>

        <!-- Primary Site Address -->
        <mds-card [appearance]="'elevated'" class="mb-medpace-item">
            <mds-card-content>
                <h3 class="mb-8">Primary Site Address</h3>
                <div class="w-full">
                    <medpace-site-address
                        [isModal]="true"
                        [parentFormGroup]="addressFormGroup"
                        [isEditing]="addressCardMode() === 'edit'"
                    ></medpace-site-address>
                </div>
            </mds-card-content>
        </mds-card>

        <!-- Shipping Address -->
        <mds-card [appearance]="'elevated'" class="mb-medpace-item">
            <mds-card-content>
                <h3 class="mb-8">Shipping Address</h3>
                <div class="w-full">
                    <medpace-site-shipping-address
                        [isModal]="true"
                        [parentFormGroup]="shippingAddressFormGroup"
                        [isEditing]="shippingAddressCardMode() === 'edit'"
                    ></medpace-site-shipping-address>
                </div>
            </mds-card-content>
        </mds-card>

        <!-- Site CRC Information -->
        <mds-card [appearance]="'elevated'" class="mb-medpace-item">
            <mds-card-content>
                <h3 class="mb-8">Site CRC Information</h3>
                <div class="w-full">
                    <div class="mb-medpace-item">
                        <h5>Primary CRC Information</h5>
                    </div>
                    <div class="flex flex-col sm:flex-row sm:justify-between">
                        <div class="flex-1 basis-full min-w-[25%] mb-medpace-item">
                            <h5>First/Given Name</h5>
                            <span>{{ primaryCRC()?.user?.firstName }}</span>
                        </div>
                        <div class="flex-1 basis-full min-w-[25%] mb-medpace-item sm:ml-4">
                            <h5>Last/Surname</h5>
                            <span>{{ primaryCRC()?.user?.lastName }}</span>
                        </div>
                    </div>
                    <div class="flex flex-col sm:flex-row sm:justify-between">
                        <div class="flex-1 basis-full max-w-full mb-medpace-field">
                            <mds-text-field
                                id="phone"
                                [formCtrl]="baseFormGroup.controls.phoneCtrl"
                                placeholder="Type here..."
                                appearance="outline"
                                inputType="text"
                                label="Phone Number"
                                width="100%"
                                [required]="true"
                            ></mds-text-field>
                        </div>
                        <div class="flex-1 basis-full min-w-[25%] mb-medpace-item sm:ml-4">
                            <h5>Email Address</h5>
                            <span>{{ toStringOrFallback(primaryCRC()?.user?.emailAddress, 'Unspecified') }}</span>
                        </div>
                    </div>
                    <div class="mb-medpace-item">
                        <label>Would you like to add supporting CRCs?</label>
                    </div>
                    <div class="mb-medpace-item">
                        <mds-radio-group
                            [buttons]="supportingCrcRadioButtons"
                            [formCtrl]="baseFormGroup.controls.supportingRadioButtons"
                            id="supportingCRC"
                            (changeEvent)="selectSupportingCrcValue($event)"
                        >
                        </mds-radio-group>
                    </div>
                    @if (hasSupportingCrc()) {
                        @for (formGroup of supportingCrcFormArray.controls; track $index; let i = $index) {
                            <div [attr.data-cy]="'supportingCrcs'">
                                <div class="flex flex-col sm:flex-row sm:justify-between gap-4">
                                    <div class="flex-1 basis-1/2 mb-medpace-field">
                                        <mds-text-field
                                            id="firstName{{ i }}"
                                            [formCtrl]="formGroup.controls.firstNameCtrl"
                                            placeholder="Type here..."
                                            appearance="outline"
                                            inputType="text"
                                            label="First/Given Name"
                                            width="100%"
                                            [required]="true"
                                        ></mds-text-field>
                                    </div>
                                    <div class="flex-1 basis-1/2 mb-medpace-field">
                                        <mds-text-field
                                            id="lastName{{ i }}"
                                            [formCtrl]="formGroup.controls.lastNameCtrl"
                                            placeholder="Type here..."
                                            appearance="outline"
                                            inputType="text"
                                            label="Last/Surname"
                                            width="100%"
                                            [required]="true"
                                        ></mds-text-field>
                                    </div>
                                </div>
                                <div class="mb-medpace-field">
                                    <mds-text-field
                                        id="email{{ i }}"
                                        [formCtrl]="formGroup.controls.emailCtrl"
                                        placeholder="Type here..."
                                        appearance="outline"
                                        inputType="text"
                                        label="Email Address"
                                        width="100%"
                                        [required]="true"
                                    ></mds-text-field>
                                </div>
                                @if (supportingCrcFormArray.length > 1) {
                                    <div class="mb-medpace-item">
                                        <mds-button
                                            [variant]="'outline'"
                                            [color]="'warn'"
                                            [label]="'Remove supporting CRC'"
                                            [id]="'removeCrcBtn'"
                                            (clickEvent)="removeSupportingCRC(i)"
                                        ></mds-button>
                                    </div>
                                }
                            </div>
                        }

                        @if (supportingCrcFormArray.length <= 4) {
                            <div class="mb-medpace-item">
                                <mds-button
                                    [variant]="'outline'"
                                    [label]="'Add supporting CRC'"
                                    [id]="'addCrcBtn'"
                                    (clickEvent)="addSupportingCRC()"
                                ></mds-button>
                            </div>
                        }
                    }
                </div>
            </mds-card-content>
        </mds-card>

        <!-- Verify Checkbox -->
        <div class="mb-medpace-item">
            <mds-checkbox
                [disabled]="false"
                [indeterminate]="false"
                [label]="'I have reviewed the details presented in this form, and I confirm that the information provided by me is accurate and complete.'"
                [checked]="false"
                [required]="true"
                id="verifyCheckbox"
                [formCtrl]="baseFormGroup.controls.verifyCheckboxControl"
            ></mds-checkbox>
        </div>
    </mds-dialog-content>
    <mds-dialog-actions [align]="'end'">
        <div class="flex flex-row gap-medpace">
            <mds-button
                [id]="'cancel-btn'"
                mat-button
                mat-dialog-close
                label="Cancel"
                variant="outline"
                (clickEvent)="cancel()"
            ></mds-button>
            <mds-button
                [id]="'completeBtn'"
                mat-button
                [attr.data-cy]="'closeButton'"
                label="Complete registration"
                (clickEvent)="validAndClose()"
                [color]="'primary'"
                [variant]="'filled'"
            ></mds-button>
        </div>
    </mds-dialog-actions>
</mds-dialog>
